export default "__VITE_ASSET__1FfYlGLl__"